/* global __DASHBOARD_ENV__ */
// Build-time constant injected by vite.config's `define` from the --env-file-loaded REACT_APP_* vars.
// Runtime code reads config only through here — never process.env / import.meta.env directly.
const raw = __DASHBOARD_ENV__;

export const env = {
  apiUrl: raw.REACT_APP_API_URL,
  // Base for the price/balance websocket (e.g. wss://api-development.lightpay.dev).
  websocketAddress: raw.REACT_APP_WEBSOCKET_ADDRESS,
  // Environment label shown in the header badge (e.g. "Development"/"Sandbox"/"Production").
  environment: raw.REACT_APP_ENVIRONMENT,
  auth0Domain: raw.REACT_APP_AUTH0_DOMAIN,
  auth0ClientId: raw.REACT_APP_AUTH0_CLIENT_ID,
  auth0Audience: raw.REACT_APP_AUTH0_AUDIENCE,
  // The registered Auth0 callback/base URL for this environment+brand.
  appUrl: raw.REACT_APP_URL,
  // Build-time brand ("bitcashier" | "dynamopayments"). The brand's config/assets are resolved
  // through the `$brand` vite alias; this is only for logging/diagnostics.
  brand: raw.REACT_APP_BRAND,
  sentryKey: raw.REACT_APP_SENTRY_KEY,
  // Google Analytics property, set for production builds only ("" elsewhere = disabled).
  gaKey: raw.REACT_APP_GA_KEY,
  blockExplorer: {
    bitcoin: raw.REACT_APP_BLOCK_EXPLORER,
    ethereum: raw.REACT_APP_BLOCK_EXPLORER_ETH,
    tron: raw.REACT_APP_BLOCK_EXPLORER_TRON,
    addressPath: raw.REACT_APP_BLOCK_EXPLORER_ADDRESS,
    txPath: raw.REACT_APP_BLOCK_EXPLORER_TX,
    tronTxPath: raw.REACT_APP_BLOCK_EXPLORER_TRANSACTION,
  },
};
